import React from "react";

export default ({ fill = "#646F81" }) => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1231_4436)">
            <path
                d="M8.77246 1.17676L16.0146 6.06055L15.7354 6.47461L15.4561 6.88965L14.5635 6.28711V15.1143H2.4209V6.28809L1.5293 6.88965L1.25 6.47461L0.970703 6.06055L8.21289 1.17676L8.49316 0.988281L8.77246 1.17676ZM3.4209 5.61426V14.1143H13.5635V5.61328L8.49316 2.19531L3.4209 5.61426Z"
                fill={fill}
            />
            <path
                d="M10.0906 5.5L10.5565 5.68151L10.8221 5H10.0906V5.5ZM6.90915 5.5V5H6.5058L6.42047 5.39422L6.90915 5.5ZM6 9.70001L5.51132 9.59423L5.38019 10.2L6 10.2L6 9.70001ZM7.81818 9.7H8.31818V9.2L7.81818 9.2L7.81818 9.7ZM7.81818 12.5H7.31818L8.2313 12.7817L7.81818 12.5ZM11 7.83335L11.4131 8.11501L11.9461 7.33335H11V7.83335ZM9.18155 7.83335L8.71566 7.65183L8.45013 8.33335H9.18155V7.83335ZM10.0906 5.5V5H6.90915V5.5V6H10.0906V5.5ZM6.90915 5.5L6.42047 5.39422L5.51132 9.59423L6 9.70001L6.48868 9.80579L7.39783 5.60578L6.90915 5.5ZM6 9.70001L6 10.2L7.81818 10.2L7.81818 9.7L7.81818 9.2L6 9.20001L6 9.70001ZM7.81818 9.7H7.31818L7.31818 12.5H7.81818H8.31818V9.7H7.81818ZM7.81818 12.5L8.2313 12.7817L11.4131 8.11501L11 7.83335L10.5869 7.55168L7.40507 12.2183L7.81818 12.5ZM11 7.83335V7.33335H9.18155V7.83335V8.33335H11V7.83335ZM9.18155 7.83335L9.64744 8.01486L10.5565 5.68151L10.0906 5.5L9.62475 5.31849L8.71566 7.65183L9.18155 7.83335Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1231_4436">
                <rect width="17" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
